import { createSlice } from '@reduxjs/toolkit'

const permissionsSlice = createSlice({
  name: 'permissions',
  initialState: {
    permissions: {}, // { '/dashboard': { canView: true, canEdit: true } }
    loading: false
  },
  reducers: {
    setPermissions: (state, action) => {
      // 👇 handle both cases - direct array or wrapped in data
      const data = Array.isArray(action.payload)
        ? action.payload
        : action.payload?.data || []

      const perms = {}
      data?.forEach(menu => {
        perms[menu.path] = {
          canView: menu.permissions?.[0]?.canView || false,
          canEdit: menu.permissions?.[0]?.canEdit || false
        }
        menu.subMenus?.forEach(sub => {
          perms[sub.path] = {
            canView: sub.permissions?.[0]?.canView || false,
            canEdit: sub.permissions?.[0]?.canEdit || false
          }
        })
      })
      state.permissions = perms
    },
    clearPermissions: (state) => {
      state.permissions = {}
    }
  }
})

export const { setPermissions, clearPermissions } = permissionsSlice.actions
export default permissionsSlice.reducer
